import {
	getPersonStatusText,
	PersonStatusColorMap,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils';
import { DocumentWorkflowInstanceSignatureStatus } from '@dealstack/shared/lib/generated';
import { Flex, HoverCard, Text } from '@mantine/core';
import { StatusInitialBadge } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/StatusInitialBadge';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	person: {
		firstName?: string | null;
		lastName?: string | null;
		status?: DocumentWorkflowInstanceSignatureStatus | null;
		roleName?: string | null;
		invitedExternally?: boolean | null;
	};
}

export const PersonHoverInfo = ({ person }: Props) => {
	const tMipManage = useTranslationMipManage();

	const firstName = person.firstName ?? tMipManage('documents_page.person.unknown_name');
	const lastName = person.lastName ?? tMipManage('documents_page.person.unknown_name');
	const isNoSignatureRequired = person.status == null;
	const status = person.status ?? DocumentWorkflowInstanceSignatureStatus.CREATED;
	const statusColor = isNoSignatureRequired
		? PersonStatusColorMap.NO_SIGNATURE_REQUIRED
		: PersonStatusColorMap[status];

	return (
		<HoverCard position="bottom" withinPortal closeDelay={0}>
			<HoverCard.Target>
				<div key={`${firstName}-${lastName}`}>
					<StatusInitialBadge
						firstName={firstName}
						lastName={lastName}
						textColor={statusColor}
					/>
				</div>
			</HoverCard.Target>
			<HoverCard.Dropdown p="0.5rem">
				<Flex direction="column">
					<Text fw={600} fs="0.875rem">{`${firstName} ${lastName}`}</Text>
					{person.roleName && (
						<Text fs="0.75rem" c="dark.0">
							{person.roleName}
						</Text>
					)}
					{person.invitedExternally && (
						<Text fs="0.75rem" c="dark.0">
							{tMipManage('documents_page.columns.counterparty.invited_externally')}
						</Text>
					)}
					<Flex align="center" gap="0.25rem">
						<div
							style={{
								width: '0.375rem',
								height: '0.375rem',
								backgroundColor: statusColor,
								borderRadius: '50%',
								padding: '0.06rem',
							}}
						/>
						<Text fs="0.75rem">{getPersonStatusText(person.status, tMipManage)}</Text>
					</Flex>
				</Flex>
			</HoverCard.Dropdown>
		</HoverCard>
	);
};
